
import styled from 'styled-components';
import React from 'react';
import ProceduresContext from './ProceduresContext';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';

const Container = styled.div`
    padding-left:28px;
    width:200px;
    margin-top:7px;
`;

const useStyles = makeStyles((theme) => ({
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
        background:'white'
    },
  }));

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
      boxShadow: 'none',
      border: state.isFocused  ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
      "&:hover": {
        borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
      }
    }),
    menu: base => ({
      ...base,
      borderRadius: 0,
      marginTop: 0
    }),
    menuList: base => ({
      ...base,
      padding: 0,
      maxHeight : window.innerHeight - 300
    })
  };

  
  
const ProceduresStatusFilter = () => {
  const classes = useStyles();
  const context = React.useContext(ProceduresContext);

  const statusSourceList = [];
  statusSourceList.push('All');
  statusSourceList.push('Not Published');
  statusSourceList.push('Published');
  
  const {procedures,isProjectSpecific} = context;
  const selectedFunction = (context.isProjectSpecific || context.isProjectSpecificCorporate) ?  procedures.selectedProjectFunction : procedures.selectedFunction;
  let proceduresList = procedures.procedures;

  // filter out non archived procedures
  proceduresList = proceduresList.filter((pl) => { return (pl.archived === false)});

  if (context.isProjectSpecific) {
    proceduresList = procedures.projectSpecificProcedures;
  } else if(context.isProjectSpecificCorporate) {
    proceduresList = procedures.projectSpecificCorporateProcedures;
  }

   // exclude archived procedures
   proceduresList = proceduresList.filter((pl) => { return (!pl.archived)});
   
  // if category filter exists then apply that first
  if (context.categoryFilterText !== "" && context.categoryFilterText !== "All") {
    proceduresList = proceduresList.filter((pl) => { return (pl.categoryName && pl.categoryName === context.categoryFilterText)});
  }
  proceduresList = context.sortProceduresList(proceduresList);
  
  // filter count for each status to display next to it
  let filteredStatus = [];
  statusSourceList.forEach(function (status, index) {
    const isNew = (status === 'Not Published') ? true : false;
    filteredStatus = proceduresList.filter((p) => { return  (p.isNew === isNew);});
      statusSourceList[index] = (status === 'All') ? status : status + ' (' + filteredStatus.length + ')';
  });

  const buildStatusData = status => {
    return { label: status, value : status }
  }

  let statusListToDisplay = statusSourceList.map(buildStatusData);
  let statusList = [
    {
        label: "Status",
        options: statusListToDisplay
    },
  ]

  return <Container>
    <Select
      classes={classes}
      styles={customStyles}
      options={statusList}
      onChange={(selectedStatus) => {
        const status = selectedStatus.value.substring(0, selectedStatus.value.indexOf( ' (' ));
        let isNew = 'All';
        if (status !== '') {
          isNew = (status === 'Not Published') ? true : false;
        }
        context.setStatusFilterText(isNew);
        context.showSnackBarMessage("Filter Successfully Applied.",null,4000);
      }}
      placeholder="Status"
      
    />
  </Container>
}

export default  ProceduresStatusFilter;